/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AeroInDB, UnitType } from 'src/api';
import { ConceptInputComponent } from '../../../forms/input/concept-input.component';
import { InputType } from '@ansys-internal/awc-angular/forms';
export type SetPart = [value: string, type: string, id: string, index?: number];

@Component({
    selector: 'app-aerodynamics-inputs',
    templateUrl: './aerodynamics.component.html',
    styleUrls: ['../inputs.scss'],
    imports: [ConceptInputComponent]
})
export class AerodynamicsComponent {
  @Input() part!: AeroInDB;
  @Input() update!: boolean;
  @Input() readonly!: boolean;
  @Output() setPart: EventEmitter<SetPart> = new EventEmitter<SetPart>();
  protected UnitType = UnitType;
  protected InputTypes = InputType;
}
